import { useSelector } from "react-redux";

export default function useAuthAdmin() {
  const auth = useSelector((state) => state.auth);
  return auth?.accessToken && auth?.user && auth?.user?.role === "admin"
    ? true
    : false;
}
